export const SCHEDULING_TESTID_PREFIX = 'scheduling';

export const testIdSlug = (value?: string | number | null): string =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const schedulingTestId = (...parts: Array<string | number | null | undefined>): string =>
  [SCHEDULING_TESTID_PREFIX, ...parts.map(testIdSlug)].filter(Boolean).join('-');

export const schedulingRowTestId = (
  base: string,
  identity: string | number | null | undefined,
  suffix?: string
): string | undefined =>
  testIdSlug(identity) ? schedulingTestId(base, identity, suffix) : undefined;

// A task keeps this id wherever it renders -- the unassigned pool or a therapist's column -- so
// the same locator resolves before and after a drag. Scope it with therapistColumnTestId to
// assert where it landed.
export const taskTestId = (taskUuid: string | null | undefined, suffix?: string) =>
  schedulingRowTestId('task', taskUuid, suffix);

export const therapistColumnTestId = (therapistUuid: string | null | undefined, suffix?: string) =>
  schedulingRowTestId('therapist-column', therapistUuid, suffix);

// A collapsed column shows one chip per assigned patient (per appointment when split). The same
// patient can sit in two therapists' columns, so the chip is keyed by both.
export const assignedPatientTestId = (
  therapistUuid: string | null | undefined,
  patientKey: string | null | undefined
): string | undefined =>
  testIdSlug(therapistUuid) && testIdSlug(patientKey)
    ? schedulingTestId('therapist-column', therapistUuid, 'patient', patientKey)
    : undefined;

export const therapistFilterOptionTestId = (therapistUuid: string | null | undefined) =>
  schedulingRowTestId('therapist-filter-option', therapistUuid);

// For the shared common-modals, which take their ids from the caller.
export const confirmCancelTestIds = (dialog: string) => ({
  confirm: schedulingTestId(dialog, 'confirm'),
  cancel: schedulingTestId(dialog, 'cancel'),
  acknowledge: schedulingTestId(dialog, 'acknowledge'),
});
